//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
    name: 'expiresIn',
    standalone: false
})
export class ExpiresInPipe implements PipeTransform {

  constructor(private readonly translationService: TranslateService) {}

  transform(value: string, ...args: unknown[]): string {
    const now = new Date();
    const then = new Date(value);
    const diffSeconds = (then.getTime() - now.getTime()) / 1000;
    const diffDays = diffSeconds / 86400;

    if(value == null) {
      return this.translationService.instant('NEVER');
    }

    if (args.length === 1 && args[0] === 'long') {
      if (diffDays < 0) {
        return this.translationService.instant('expires-in-pipe.long.days-ago', {days: Math.abs(diffDays).toFixed(0)});
      } else {
        return this.translationService.instant('expires-in-pipe.long.days-from-now', {days: Math.abs(diffDays).toFixed(0)});
      }
    } else {
      if (diffSeconds <= 0) {
        return this.translationService.instant('expires-in-pipe.already-expired');
      } else if (diffSeconds <= 43200) {
        return this.translationService.instant('expires-in-pipe.today');
      } else if (diffSeconds <= 86400 * 2) {
        return this.translationService.instant('expires-in-pipe.tomorrow');
      } else if (diffDays < 365) {
        return this.translationService.instant('expires-in-pipe.in-days', {days: diffDays.toFixed()});
      } else if (diffDays <= 730) {
        return this.translationService.instant('expires-in-pipe.next-year');
      } else if(diffDays > 730) {
        return this.translationService.instant('expires-in-pipe.years');
      }
    }
    throw new Error("Error interpreting date!");
  }

}
